export default __webpack_public_path__ + "static/table-9cb283362d5b307d833fa2ac8f8758b8.svg";